/**
 * 图片URL处理工具
 * 统一处理相对路径和完整URL
 */

/**
 * 获取完整的图片URL
 * @param {string} image - 图片路径（相对路径或完整URL）
 * @returns {string} 完整的图片URL
 */
export function getImageUrl(image) {
  // 如果没有图片，返回空字符串
  if (!image) {
    return ''
  }

  // 如果图片URL已经是完整URL（http://或https://开头），直接返回
  if (image.startsWith('http://') || image.startsWith('https://')) {
    return image
  }

  // 如果是相对路径（以/开头）
  if (image.startsWith('/')) {
    // 开发环境：使用域名，避免IP访问502错误
    if (process.env.NODE_ENV === 'development') {
      return `http://xiangyuanwuliu.com${image}`
    }
    // 生产环境：使用门户网站的完整HTTPS URL
    return `https://www.xiangyuanwuliu.com${image}`
  }

  // 其他情况直接返回
  return image
}

